import Spinner from 'react-bootstrap/Spinner';
import { Buffer } from "buffer";
import {
  useAccount,
  useConnect,
  useDisconnect
} from 'wagmi';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import QRCode from "react-qr-code";
import { clearUserItemsCache } from '../api/FileManagementApi';
window.Buffer = Buffer;

const onPop = () => {
  window.history.go(-2);
}

export function QrCode() {

  const sendNftStatus = (sign_on_status) => {
    try {
      window.appStatus("nft.status",sign_on_status,"na","2");
    }
    catch(error) {
      console.log(error);
    }
  }

  const navigate = useNavigate();
  const { id } = useParams();
  const { address, isConnected:accountIsConnected } = useAccount()
  const { connect, connectors, isLoading:connectLoading, isSuccess: connectSuccess, isError: connectError } = useConnect();
  const { disconnect, isSuccess: disconnectSuccess } = useDisconnect();
  const [wcUri, setWcUri] = useState(null);//WalletConnect pairing link shown as our own QR code
  const qrShown = useRef(false);//true once a QR was shown for the current connect attempt

  //WalletConnect's modal is disabled (showQrModal: false in App.js), so listen for the pairing link ourselves.
  useEffect(()=>{
    if(id != 0) {
      return;
    }
    const connector = connectors[0];
    const onMessage = ({ type, data }) => {
      if(type === 'display_uri') {
        qrShown.current = true;
        setWcUri(data);
      }
    };
    connector.on('message', onMessage);
    return () => {
      connector.off('message', onMessage);
    }
  },[]);

  //the QR expired or the user rejected in the wallet: start a new attempt so a fresh QR is shown.
  //Only retry if this attempt showed a QR, so a setup failure (e.g. no network) doesn't loop.
  useEffect(()=>{
    if(connectError && id == 0 && qrShown.current) {
      console.log("WalletConnect attempt ended, showing a new QR");
      qrShown.current = false;
      setWcUri(null);
      connect({ connector: connectors[0] });
    }
  },[connectError]);

  //immediately after opening the QrCode page check if the user is connected or not.
  useEffect(()=>{
    let connector = connectors[id];
    if(!accountIsConnected) {
      console.log("User was not connected");
      connect({ connector });
    }
    else {
      disconnect();
    }

    localStorage.setItem("shouldGoBack",true);
    localStorage.setItem("isDashboard",false);

    window.history.pushState({},"","SignInFakeRoutwe");
    window.addEventListener('popstate',onPop, { once: true });

    return () => {
      window.location.reload();
    }
  },[]);

  //after succesfully disconnecting, invoke connect().
  useEffect(()=>{
    if(disconnectSuccess) {
      let connector = connectors[id];
      console.log("Disconnected Sucessfully");
      localStorage.setItem("metaMaskAccount", 'null');
      clearUserItemsCache();
      sendNftStatus("2");
      connect({ connector });
    }
  },[disconnectSuccess]);

  useEffect(()=>{
    if(connectSuccess) {
      window.removeEventListener('popstate',onPop);
      navigate(-3);
    }
  });


  if(id == 0 && wcUri && !connectSuccess) {
    return (
      <div className="custom-center" style={{height:"100vh"}}>
        <div style={{ width: '40vh', backgroundColor: 'white', padding: '2vh' }}>
          <QRCode
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={wcUri} />
        </div>
      </div>
    )
  }

  if(connectLoading) {
    return (
      <div className="custom-center" style={{height:"100vh"}}>
          <Spinner animation="border" role="status" variant="light">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
      </div>
    )
  }

  if(connectSuccess) {
    localStorage.setItem("metaMaskAccount", address);
    sendNftStatus("0");
    return (
      <div className="custom-center" style={{height:"100vh",color:'#9bb878'}}>
            Account: {address} connected. Please go back to the dashboard.
      </div>
    )
  }

}
